import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../../app.component';
import swal from 'sweetalert';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css']
})

export class CallbackComponent implements OnInit {
  url;
  url_pdf;
  recaudadora;
  tipo;
  cuenta;
  aut;
  tipoPeticion;
  transactionId;
  pagos: any[] = [];
  year_actual;
  autorizacion_banco;
  MensajeSweet;
  presupuesto;
  presupuesto_params_encriptado;
  presupuesto_url;
  url_valida_presupuesto_participativo;
  params_ventana_presupuesto_participativo;

  constructor(private route: ActivatedRoute, public global: AppComponent, private http: HttpClient) { 
    this.url = global.url;
    this.url_pdf = global.url_pdf;
    this.params_ventana_presupuesto_participativo = global.params_ventana_presupuesto_participativo;
    this.recaudadora = this.route.snapshot.paramMap.get('recaudadora');
    this.tipo = this.route.snapshot.paramMap.get('tipo');
    this.cuenta = this.route.snapshot.paramMap.get('cuenta');
    this.aut = this.route.snapshot.paramMap.get('aut');
    this.tipoPeticion = this.route.snapshot.paramMap.get('tipoPeticion');
    this.transactionId = this.route.snapshot.paramMap.get('transactionId');
    this.autorizacion_banco = null;
    /*
    let i = 0;
    let max = 8;
    (function repeat(){
      if (++i > 8) return;
      setTimeout(function(){
        //console.log("waited for: " + i + " seconds");
        repeat();
      }, 1000);
    })();
    */
    /*
    setTimeout(() => {
      this.consultar_pagos();
    }, 6000);
    */
    this.consultar_pagos();
  }

  ngOnInit(): void {
    /*
    if(this.global.web_status==='M'){
      this.global.mostrar = false;
      this.global.mostrar_mantenimiento = true;
    }
    */
    //this.global.validaHoraServicio();
  }//ngOnInit(): void {

  consultar_pagos(){
    //console.log("entro a consultar pagos");
    /*
    setTimeout(() => {
      console.log("10 Segundos esperado")
    }, 3000);
    */
    //setTimeout('', 5000);
    /*
    const all = [1,2,3,4,5];
    all.forEach((each, i) => {
        setTimeout(() => {
        console.log(each); // Call your http request
      }, i * 5000)
    });
    console.log("salgo de setTimeout consultar_pagos");
    */
    if(this.tipoPeticion == "app"){
      this.global.mostrar_layout = false;      
      document.querySelector('app-header').classList.add("hide");
      document.querySelector('app-footer').classList.add("hide");
    }else{
      this.tipoPeticion = "web";
      this.global.mostrar_layout = true;
      document.querySelector('app-header').classList.remove("hide");
      document.querySelector('app-footer').classList.remove("hide");
    }
    localStorage.clear();
    this.global.validaHoraServicio();
    const formData = new FormData();
    formData.append('recaudadora', this.recaudadora);
    formData.append('tipo', this.tipo);
    formData.append('cuenta', this.cuenta);

    //console.log("mando subscribe");
    //this.http.post(this.url+'consulta_adeudo', formData).subscribe((result: any) => {
    this.http.post(this.url+'consulta_pagos', formData).subscribe((result: any) => {
      try {
        /*
        array('status' => TRUE,  'tipo'=>'1',  'message' => 'CUENTA PREDIAL VALIDA',  'data' => ($data_api));
        array('status' => FALSE, 'tipo'=>'0',  'message' => 'ERROR PROCESAMIENTO 2',  'data' => ($data_api));
        array('status' => FALSE, 'tipo'=>'0',  'message' => 'ERROR PROCESAMIENTO 1',  'data' => ($data_api));
        array('status' => FALSE, 'tipo'=>'-1', 'message' => 'MANTENIMIENTO PROCESOS', 'data' => ($data_api));
        array('status' => FALSE, 'tipo'=>'-2', 'message' => 'PROCESANDO PAGOS',       'data' => ($data_api));
        array('status' => FALSE, 'tipo'=>'-3', 'message' => 'MANTENIMIENTO SISTEMAS', 'data' => ($data_api));
        */
        if (result.status === true) {
          this.pagos = result.data.pagos;
          //console.log(this.pagos);
          //console.log(this.pagos[0]);

          if(result.data['presupuesto']){
            this.presupuesto = result.data['presupuesto'];
            this.presupuesto_params_encriptado = result.data['presupuesto_params_encriptado'];
            this.presupuesto_url = result.data['presupuesto_url'];

            this.url_valida_presupuesto_participativo = this.global.url_presupuesto_participativo + this.presupuesto_params_encriptado;
            //alert('this.presupuesto_url:'+this.presupuesto_url);
            //alert('this.url_valida_presupuesto_participativo:'+this.url_valida_presupuesto_participativo);
            //alert('this.params_ventana_presupuesto_participativo:'+this.params_ventana_presupuesto_participativo);
            if(this.url_valida_presupuesto_participativo == this.presupuesto_url){
              //console.log("url igual:"+this.url_valida_presupuesto_participativo+"---"+this.presupuesto_url);
              //window.open(this.presupuesto_url, this.params_ventana_presupuesto_participativo);
              //setTimeout(() => window.open(this.presupuesto_url, this.params_ventana_presupuesto_participativo), 3000);
              
              //console.log("this.tipoPeticion:"+this.tipoPeticion);
              ////if(this.tipoPeticion == "web"){
                setTimeout(() => this.global.abre_ventana(this.presupuesto_url));
                //window.open(this.presupuesto_url, '_blank');
              ////}
            }else{
              //console.log("url distinta:"+this.url_valida_presupuesto_participativo+"---"+this.presupuesto_url);
            }
          }else{//if(result.data['presupuesto']){
            //alert('no mostrar presupuesto participativo');
          }//if(result.data['presupuesto']){}else{          
          
          for (let array_pagos of this.pagos){
            //console.log(array_pagos);
            //console.log(array_pagos['year_pago']+' '+array_pagos['autorizacion_banco']);
            //if(array_pagos['year_pago'] == this.global.year_actual && array_pagos['referencia'] == this.aut){
            if(array_pagos['year_pago'] == this.global.year_actual){
              this.autorizacion_banco = array_pagos['autorizacion_banco'];
            }
          }

        } else {
          /*
          array('status' => TRUE,  'tipo'=>'1',  'message' => 'CUENTA PREDIAL VALIDA',  'data' => ($data_api));
          array('status' => FALSE, 'tipo'=>'0',  'message' => 'ERROR PROCESAMIENTO 2',  'data' => ($data_api));
          array('status' => FALSE, 'tipo'=>'0',  'message' => 'ERROR PROCESAMIENTO 1',  'data' => ($data_api));
          array('status' => FALSE, 'tipo'=>'-1', 'message' => 'MANTENIMIENTO PROCESOS', 'data' => ($data_api));
          array('status' => FALSE, 'tipo'=>'-2', 'message' => 'PROCESANDO PAGOS',       'data' => ($data_api));
          array('status' => FALSE, 'tipo'=>'-3', 'message' => 'MANTENIMIENTO SISTEMAS', 'data' => ($data_api));
          */
          switch (result.tipo) {
            case '-1': //MANTENIMIENTO PROCESOS
            case '-3': //MANTENIMIENTO SISTEMAS
              //this.global.mostrar = false;
              this.global.mostrar_mantenimiento = true;
            break;
            
            case '-2': //PROCESANDO PAGOS
              //this.global.mostrar = false;
              this.global.mostrar_procesando_pagos_callback = true;
            break;

            default:
              this.MensajeSweet = result.message;
              swal("¡Error!", this.MensajeSweet, "error");
              
              this.global.mostrar = false;
            break;
          }
          
          this.pagos = null;
        }
      } catch (error) {
        
      }
    });
  }//consultar_pagos(){  
}